



















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { ISortParameter } from "../../../../base/components/system";
import { TimeMeasure } from "../../../../base/utilities";
import { DomainRegistry } from "../../../domain";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FormatSortSelector } from "./FormatSortSelector.vue";
import { default as FormatTableSelector } from "./FormatTableSelector.vue";
import { default as DeletedEditableFormatSummaryFilter } from "../filters/DeletedEditableFormatSummaryFilter.vue";
import { EditableFormatSummaryFilterParameter } from "../filters";

@Component({
  components: {
    DeletedEditableFormatSummaryFilter,
    FormatSortSelector,
    FormatTableSelector,
  }
})
export default class DeletedFormatSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isShown: boolean;

  isLoaded: boolean = false;
  isFormatLoading: boolean = false;
  deletedFormats: EditableFormatSummary[] = [];
  sortedValues: EditableFormatSummary[] = [];
  sortParameter: ISortParameter = {
    order: "descending",
    property: "lastUpdateDateTime",
  };
  formatFilter: EditableFormatSummaryFilterParameter = new EditableFormatSummaryFilterParameter("", null, "", "", true, true);

  mounted(): void {
    if (this.isShown) {
      this.isLoaded = true;
      this.loadDeletedFormats();
    }
  }

  get deletedFilterFormats(): EditableFormatSummary[] {
    return Enumerable.from(this.deletedFormats).where(s => this.filterFormat(s)).toArray();
  }

  get filterFormat(): (source: EditableFormatSummary) => boolean {
    return this.createFormatFilter(this.formatFilter);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  createFormatFilter(source: EditableFormatSummaryFilterParameter): (source: EditableFormatSummary) => boolean {
    return s => source.filter(s);
  }

  @Watch("isShown")
  onIsShownUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue && !this.isLoaded) {
      this.isLoaded = true;
      this.loadDeletedFormats();
    }
  }

  async loadDeletedFormats(): Promise<void> {
    this.isFormatLoading = true;
    this.deletedFormats = [];
    let formats = [] as EditableFormatSummary[];
    await this.getDeletedFormats()
    .then(d => formats = d)
    .catch(e => {
      this.isFormatLoading = false;
      this.$error(
        "削除" + this.formatNameWording + "取得失敗",
        "削除" + this.formatNameWording + "を読み込めませんでした。",
        e
      );
    });
    await this.getNoneDisplayFormats()
    .then(d => {
      formats = formats.concat(d);
      this.deletedFormats = formats;
    })
    .catch(e => {
      this.$error(
        "非表示な" + this.formatNameWording + "取得失敗",
        "非表示な" + this.formatNameWording + "を読み込めませんでした。",
        e
      );
    })
    .finally(() => this.isFormatLoading = false);
  }

  private getDeletedFormats(): Promise<EditableFormatSummary[]> {
    return TimeMeasure.logAsync(
      "削除された" + this.formatNameWording + "取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getDeletedFormats();
      },
      "",
      TimeMeasure.debug
    );
  }

  private getNoneDisplayFormats(): Promise<EditableFormatSummary[]> {
    return TimeMeasure.logAsync(
      "削除された" + this.formatNameWording + "取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getNoneDisplayFormats();
      },
      "",
      TimeMeasure.debug
    );
  }

  onSortChanged(param: ISortParameter): void {
    this.sortParameter = param;
  }
}
